import { Component, OnInit, NgZone, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { ControlPosition, MapTypeControlOptions, MapsAPILoader, MouseEvent } from '@agm/core';
import { Observable } from 'rxjs';
import { reduce, takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { LatLngLiteral } from '@agm/core';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { environment } from 'src/environments/environment';
import { CsvService } from 'src/app/service/csv-service/csv.service';
import * as moment from 'moment';
import { AssigTripsService } from 'src/app/component/assigned-trips/assigntrips-service/assigntrips-service';
import { CorporateService } from 'src/app/component/corporate-user/corporate-service/corporate-service';
import { DispatchCenterService } from 'src/app/component/dashboard/dashboard-service/dispatch-center-service';
import { sweetAlert } from 'src/app/utils/swal';
import { checkRole, loadStaticMap } from 'src/app/utils/utils.common';
import { UserRoles } from 'src/app/component/shared/layout/menu-service/menu.service';

@Component({
  selector: 'app-trip-details',
  templateUrl: './trip-details.component.html',
  styleUrls: ['./trip-details.component.css']
})
export class TripDetailsComponent implements OnInit, OnDestroy {
  @Input() tripId: any
  @Input() openFrom?: any
  @Output() onCloseModal = new EventEmitter<any>();
  address: string;
  zoom: number;
  jobId;
  trackinURL;
  tripDetails = null;
  jobAcceptedUrl = null;
  jobOnSceneUrl = null;
  jobStartedUrl = null;
  jobEndedUrl = null;
  jobFinishedUrl = null;
  jobCancelledUrl = null;
  mapTypeControlOptions: MapTypeControlOptions = {
    position: ControlPosition.TOP_LEFT
  };
  isDrawRoute = false;
  origin = { lat: 0.00000, lng: 0.00000 };
  destination = { lat: 0.00000, lng: 0.00000 };
  assign;
  cameraImages;
  user;
  tripAssistance: {
    displayName: '',
    contactNumber: ''
  };
  contact
  timeZone 
  todayDate = [];
  isAllowRates = false;
  constructor(
    private corporateService: CorporateService,
    private dispatchCenterService: DispatchCenterService,
    private assigTripsService: AssigTripsService,
    private sharedDataService: SharedDataService,
    private csvService : CsvService
  ) { }

  ngOnInit() {
    this.trackinURL = environment.TRACKING_URL;
    this.jobId = this.tripId;
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(user => {
        if (user) {
          this.user = user;
          this.timeZone = user.timeZone;
          this.todayDate = [
            moment.tz(this.timeZone).startOf("day").toISOString(),
            moment.tz(this.timeZone).endOf("day").toISOString(),
          ];

          this.getCompletedTripDetail();
          this.isAllowRates = checkRole(this.user);
        }
      });
  }

  twodigit(val) {
    return parseFloat(Number(Math.round(parseFloat(val)) + 'e-0').toFixed(2));
  }

  closeDetailModal() {
    this.onCloseModal.emit();
  }

  breakString(str) {
    if (!str) return "";
    return str.replace(/\n/g, "<br>");
  }

  isStringExist(substrings, str) {
    if (substrings.some(v => str.toLowerCase().includes(v))) {
      return true;
    }
    return false;
  }

  sendSMS() {
    if (!this.tripAssistance.displayName || !this.tripAssistance.contactNumber) return;
    this.assigTripsService
      .sendTripAssistanceSMS(this.tripDetails._id, this.tripAssistance)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          if (data.success) {
            sweetAlert('Success', data.message + ' ' + data.link, 'success', 'OK');
          } else {
            sweetAlert('Error', data.message, 'error', 'OK');
          }
        }
      });
  }

  sendTrackingSMS() {
    if (!this.contact) return;
    this.tripDetails.contactNumber = this.contact;

    const payload = {
      ...this.tripDetails,
      tripId: this.tripDetails._id,
      latitude: this.tripDetails.driver.latitude,
      longitude: this.tripDetails.driver.longitude,
    }
    this.assigTripsService
      .sendTrackingSMS(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          // this.contact = '';
          if (data.success) {
            sweetAlert('Success', data.message, 'success', 'OK');
          } else {
            sweetAlert('Error', data.message, 'error', 'OK');
          }
        }
      });
  }

  getCompletedTripDetail() {
    this.dispatchCenterService.getTripDetail(this.jobId).subscribe(data => {
      if (data) {
        this.tripDetails = data;

        this.tripAssistance = {
          displayName: this.tripDetails.priorityClient.displayName,
          contactNumber: this.tripDetails.priorityClient.contactNumber
        };


        if (this.tripDetails.job && this.tripDetails.job.trackInfoJob) {

          if (this.tripDetails.job.trackInfoJob.jobAccepted)
          this.jobAcceptedUrl = loadStaticMap(this.tripDetails.job.trackInfoJob.jobAccepted.coords[1],
            this.tripDetails.job.trackInfoJob.jobAccepted.coords[0]);

            if (this.tripDetails.job.trackInfoJob.jobArrived)
          this.jobOnSceneUrl = loadStaticMap(this.tripDetails.job.trackInfoJob.jobArrived.coords[1],
            this.tripDetails.job.trackInfoJob.jobArrived.coords[0]);

            if (this.tripDetails.job.trackInfoJob.jobStarted)
          this.jobStartedUrl = loadStaticMap(this.tripDetails.job.trackInfoJob.jobStarted.coords[1],
            this.tripDetails.job.trackInfoJob.jobStarted.coords[0]);

            if (this.tripDetails.job.trackInfoJob.jobCompleted)
          this.jobEndedUrl = loadStaticMap(this.tripDetails.job.trackInfoJob.jobCompleted.coords[1],
            this.tripDetails.job.trackInfoJob.jobCompleted.coords[0]);

            if (this.tripDetails.job.trackInfoJob.jobFinished)
          this.jobFinishedUrl = loadStaticMap(this.tripDetails.job.trackInfoJob.jobFinished.coords[1],
            this.tripDetails.job.trackInfoJob.jobFinished.coords[0]);

            if (this.tripDetails.job.trackInfoJob.jobCancelled)
          this.jobCancelledUrl = loadStaticMap(this.tripDetails.job.trackInfoJob.jobCancelled.coords[1],
            this.tripDetails.job.trackInfoJob.jobCancelled.coords[0]);
        }

        this.origin = {
          lat: this.tripDetails.jobOriginLatitude,
          lng: this.tripDetails.jobOriginLongitude
        };
        this.destination = {
          lat: this.tripDetails.jobDestinationLatitude,
          lng: this.tripDetails.jobDestinationLongitude
        };
        this.getCorporateUserById();
      }
    })
  }

  getCorporateUserById() {
    this.corporateService.getCorporateUserById(this.tripDetails.cooperate)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.tripDetails.cooperate = data.displayName
          this.contact = data.contactNumber
        }


      });
  }
  ngOnDestroy(): void {
  }

}
